import { cva } from 'class-variance-authority';

export const tooltipWrapperClasses = cva([
  'relative inline-flex items-center',
  'focus-visible:outline-charcoal-500 focus:not(:focus-visible):outline-none focus-visible:rounded focus-visible:outline-2 focus-visible:outline-offset-2'
]);

export const tooltipContentClasses = cva(
  'text-white-50 bg-charcoal-500 border-charcoal-425 fixed z-[var(--z-on-top)] max-w-[290px] rounded-lg border px-4 py-3 text-[14px] leading-4 font-normal whitespace-pre-wrap',
  {
    variants: {
      side: {
        top: 'after:border-t-charcoal-500 after:bottom-[-4px] after:left-3 after:border-t-4 after:border-r-4 after:border-l-4 after:border-r-transparent after:border-l-transparent',
        right:
          'after:border-r-charcoal-500 after:top-1/2 after:left-[-4px] after:-translate-y-1/2 after:border-t-4 after:border-r-4 after:border-b-4 after:border-t-transparent after:border-b-transparent'
      }
    },
    defaultVariants: {
      side: 'top'
    }
  }
);
